import { Grid } from '@mui/material';
import { getMonthStartAndEnd } from '@nx-smartmonkey/shared/helpers';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import * as routing from '../../../../constants/Routing';
import { useRetrieveActiveLanguage } from '../../../../hooks/translations/useRetrieveActiveLanguage';
import { useRetrieveVehicle } from '../../hooks/useRetrieveVehicle';
import { DistanceSummary } from './DistanceSummary';
import { EmissionsSummary } from './EmissionsSummary';
import { StopsProgress } from './StopsProgress';
import { useRetrieveAnalyticsSummary } from './useRetrieveAnalyticsSummary';

interface HomeAnalyticsSummaryProps {
  refreshTrigger: number;
}

export const HomeAnalyticsSummary = ({ refreshTrigger }: HomeAnalyticsSummaryProps) => {
  const navigate = useNavigate();
  const { data: vehicleDetails } = useRetrieveVehicle();
  const { activeLanguage } = useRetrieveActiveLanguage();
  const { startDate, endDate } = getMonthStartAndEnd({
    date: new Date(),
    language: activeLanguage,
  });
  const { data: analyticsSummary, run: refetchAnalyticsSummary } = useRetrieveAnalyticsSummary({ startDate, endDate });

  useEffect(() => {
    refetchAnalyticsSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshTrigger]);

  return (
    <Grid
      container
      direction="row"
      wrap="nowrap"
      justifyContent="center"
      alignItems="center"
      style={{
        position: `relative`,
        zIndex: 2,
      }}
      onClick={() => {
        navigate(
          `${
            routing.PRIVATE_ROUTES.ANALYTICS
          }?start_date=${startDate.toUTCString()}&tab=distance&end_date=${endDate.toUTCString()}&bin_type=week`
        );
      }}
    >
      <DistanceSummary distance={analyticsSummary?.total_km} units={vehicleDetails?.project.units.distance} />

      <StopsProgress
        completedStops={analyticsSummary?.completed_stops}
        canceledStops={analyticsSummary?.canceled_stops}
        incompleteStops={vehicleDetails?.project.tasks_enabled ? analyticsSummary?.incomplete_stops : undefined}
        tasksEnabled={vehicleDetails?.project.tasks_enabled}
      />

      <EmissionsSummary emissions={analyticsSummary?.total_emissions} units={vehicleDetails?.project.units.weight} />
    </Grid>
  );
};
